import React from "react";
import { toast } from "react-toastify";

import { IgButton, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { IgAlertSimpleInverted } from "@src/components/Utils/IgAlertSimpleInverted";

import {
  FullIgScript,
  IgScript,
  intelligemsFullThemeSnippet,
} from "../../utils/intelligemsThemeSnippets";

interface ScriptCopyProps {
  organizationId?: string;
}
export const ScriptCopy = ({ organizationId }: ScriptCopyProps) => {
  const isAdmin = useIsAdmin();
  const onCopyClick = async () => {
    await navigator.clipboard.writeText(FullIgScript(organizationId!));
    toast.success("Script Copied!");
  };
  return (
    <IgPaper>
      <Grid container direction={"column"} rowSpacing={1}>
        <Grid
          item
          xs={12}
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Grid item>
            <IgTypography variant="h3" fontWeight={"fontWeightMedium"}>
              Theme Script
            </IgTypography>
          </Grid>
          <Grid item>
            <IgButton
              onClick={() => {
                void onCopyClick();
              }}
              variant={"contained"}
            >
              Copy Script
            </IgButton>
          </Grid>
        </Grid>
        <Grid item>
          <IgTypography sx={{ fontSize: "12px" }} variant={"code"}>
            <Grid item>{"<script>"}</Grid>
            <Grid item ml={2}>
              {`window.Shopify = window.Shopify || {theme: {id: {{ theme.id }}, role: '{{ theme.role }}' } };`}
            </Grid>
            <Grid ml={2} item>{`window._template = {`}</Grid>
            <Grid ml={6} item>{`directory: "{{ template.directory }}",`}</Grid>
            <Grid ml={6} item>{`name: "{{ template.name }}",`}</Grid>
            <Grid ml={6} item>{`suffix: "{{ template.suffix }}"`}</Grid>
            <Grid xs={12} ml={2} item>{`};`}</Grid>
            <Grid item>{`</script>`}</Grid>
            <Grid item>{IgScript(organizationId!)}</Grid>
          </IgTypography>
        </Grid>
      </Grid>
    </IgPaper>
  );
};
